import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

export const getHomework = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.HOMEWORK.GET, { params });
  return response;
};
